export interface IHandelssortimentSenasteValdPrislista {
    handelssortimentId: number;
    handelssortimentsgruppId: number;
    vlg: boolean;
    marknadsprislistaId: number;
    viol3: boolean;
    datum: string;
}

export class UtskriftInstallningar {
    handelssortimentSenasteValdaPrislistor: IHandelssortimentSenasteValdPrislista[];

    static get key(): string {
        return "Virkeskop.Kontraktsutskrift.Installning";
    }
}
